import ContactEmailForm from "@/components/ContactEmailForm";
import NewsletterSignup from "@/components/NewsletterSignup";
import { SocialExternalLinks } from "@/components/SocialExternalLinks";

const Contacto = () => (
  <div className="mx-auto max-w-[80rem] px-5 py-8 md:px-9">
    <div className="mb-5 pb-1">
      <h1 className="mt-2 font-display text-2xl font-extrabold uppercase tracking-tight text-[#13151c] md:text-3xl">
        Contacto
      </h1>
      <p className="mt-1 text-sm text-muted-foreground">Escríbenos o suscríbete a la newsletter.</p>
    </div>

    <div className="grid gap-5 lg:grid-cols-12 lg:items-stretch">
      <section className="self-start rounded-xl border border-[#13151c]/16 bg-white p-5 shadow-[0_8px_30px_rgba(19,21,28,0.05)] md:p-6 lg:col-span-7">
        <div>
          <h2 className="font-display text-lg font-bold">Envia un mensaje</h2>
          <p className="mt-1 text-sm text-muted-foreground">Colaboraciones, recomendaciones o lo que quieras.</p>
        </div>
        <div className="mt-5">
          <ContactEmailForm
            source="contact-page"
            footerRight={(
              <a href="mailto:hola@popistant.es" className="font-medium text-foreground hover:text-primary hover:underline">
                hola@popistant.es
              </a>
            )}
          />
        </div>
      </section>

      <div className="flex flex-col gap-5 lg:col-span-5">
        <section className="rounded-xl border border-[#13151c]/16 bg-white p-5 shadow-[0_8px_30px_rgba(19,21,28,0.05)] md:p-6">
          <h2 className="font-display text-lg font-bold">Newsletter</h2>
          <p className="mt-1 text-sm text-muted-foreground">Recibe un email cuando haya nuevo contenido.</p>
          <div className="mt-5">
            <NewsletterSignup source="contact-page" variant="light" />
          </div>
        </section>

        <section className="rounded-xl border border-[#13151c]/16 bg-white p-5 shadow-[0_8px_30px_rgba(19,21,28,0.05)] md:p-6 lg:flex-1">
          <h2 className="font-display text-lg font-bold">Nuestras redes</h2>
          <p className="mt-1 text-sm text-muted-foreground">Siguenos para ver conciertos, canciones y novedades de Popistant.</p>
          <div className="mt-4 text-sm">
            <SocialExternalLinks />
          </div>
        </section>
      </div>
    </div>
    <p className="mt-5 text-[11px] text-muted-foreground">
      Protegido por Cloudflare Turnstile ·{" "}
      <a href="https://www.cloudflare.com/privacypolicy/" target="_blank" rel="noreferrer" className="hover:underline">
        Privacidad
      </a>{" "}
      ·{" "}
      <a href="https://www.cloudflare.com/website-terms/" target="_blank" rel="noreferrer" className="hover:underline">
        Terminos
      </a>
    </p>
  </div>
);

export default Contacto;
